import ApiService from "@/core/services/ApiService";
import axios from "axios";
class PublicService {

    public static getEvents() {
        return ApiService.get('public/events')
    }

    public static getDetails(data: any) {
        return ApiService.get('public/events', data)
    }

    public static getClubs(data: any) {
        return ApiService.post('public/events/institutions', data)
    }

    public static options(slug: any, data: any){
        return ApiService.get(`public/events/${slug}/`, data)
    }

    public static getRanking(data: any) {
        return ApiService.post('public/events/ranking-teams', data)
    }

    public static more(data: any)
    {
        return ApiService.post('public/more', data)
    }

    public static Nominal(data: any)
    {
        return ApiService.post('public/events/nominal', data)
    }

    public static Medallero(data: any)
    {
        return ApiService.get(`public/events/${data}`, 'medals')
    }

    public static MedalleroSport(data: any, idsport: any)
    {
        return ApiService.get(`public/events/${data}`, `medals/${idsport}`)
    }

    public static getCompany(data: any)
    {
        return ApiService.get(`public/company/${data}`, `show`)
    }
    //FIXTURE
    public static getGroups(data: any){
        return axios.get(`${process.env.VUE_APP_WSCORE}groupsapi/?${data}`, { withCredentials: false })
    }

    public static getFixture(data: any){
        return axios.get(`${process.env.VUE_APP_WSCORE}fixtureapi/?${data}`, { withCredentials: false })
    }

    public static getMeeting(data: any){
        return axios.get(`${process.env.VUE_APP_WSCORE}matchesapi/?${data}`, { withCredentials: false })
    }

    public static getFecha(data: any){
        return axios.get(`${process.env.VUE_APP_WSCORE}fechas/?${data}`, { withCredentials: false })
    }

    public static getBotones(data: any){
        return axios.get(`${process.env.VUE_APP_WSCORE}flagfase/?${data}`, { withCredentials: false })
    }

    // ── Registro público de acreditación (Prensa / Jueces / Árbitros / Voluntarios) ──
    public static registerAcrd(data: any) {
        return ApiService.post('public/acrd/register', data)
    }

    public static uploadPublicPhoto(data: FormData) {
        return ApiService.vueInstance.axios.post('public/photo/upload', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    }

    public static getEventFunctions(idevent: any) {
        return ApiService.get(`public/events/${idevent}`, 'functions')
    }

    // ── Sección pública de eventos por company ──
    public static getPublicEventList(company: string) {
        return ApiService.get(`public/${company}/events`)
    }

    public static getPublicEventDetail(company: string, slug: string) {
        return ApiService.get(`public/${company}/events`, slug)
    }

    public static getPublicEventDocuments(company: string, slug: string) {
        return ApiService.get(`public/${company}/events/${slug}`, 'documents')
    }

}

export default PublicService;